export default "__VITE_ASSET__Rpd_GJZW__"